module.exports = __webpack_public_path__ + "img/gray-honourable.e0709917.png";